import { render, staticRenderFns } from "./EditMessageDialog.vue?vue&type=template&id=d8e05260"
import script from "./EditMessageDialog.vue?vue&type=script&lang=js"
export * from "./EditMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports